import { useRouter } from "next/router";
import * as React from "react";

import { useLeadFormModuleContext } from "@brexhq/next/src/components/modules/LeadForm/LeadFormModuleProvider";
import { GTMFormPageTemplate } from "@brexhq/next/src/components/modules/LeadForm/Steps/PageTemplates/GTMFormPageTemplate";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import { useBypassSuccess } from "@brexhq/next/src/components/modules/LeadForm/utils";
import { BlockRows } from "@brexhq/next/src/components/shared/BlockRows/BlockRows";
import useSiteContext from "@brexhq/next/src/hooks/useSiteContext";

export const GTMSuccess: React.FC = () => {
  const {
    leadFormSuccess,
    customProgramName,
    theme,
    bypassSuccessContentUrl,
    isInlineEmail,
  } = useLeadFormModuleContext();
  const { navigators } = useSiteContext();
  const router = useRouter();
  const bypassSuccess = useBypassSuccess();

  const { shouldBypass, link, isInternalLink } = bypassSuccess(
    bypassSuccessContentUrl,
  );
  React.useEffect(() => {
    const rerouteIfBypass = () => {
      return isInternalLink ? router.push(link) : (window.location.href = link);
    };
    if (shouldBypass) {
      rerouteIfBypass();
    }
  }, [
    bypassSuccessContentUrl,
    isInternalLink,
    link,
    navigators,
    router,
    shouldBypass,
  ]);

  return (
    <GTMFormPageTemplate
      step={LeadFormSteps.gtmSuccess}
      programName={customProgramName}
      noContent={!leadFormSuccess}
      inlineForm={isInlineEmail}
    >
      {leadFormSuccess && (
        <BlockRows
          alignment={"left"}
          rows={leadFormSuccess.textRows}
          theme={theme}
        />
      )}
    </GTMFormPageTemplate>
  );
};
